@if (!list().length) {
  <div class="flex flex-col justify-center items-center mt-8xl">
    <lib-no-user-data-icon [iconClass]="'w-21 h-20'" />

    <h6 class="text-xl font-semibold text-neutral-900 mt-lg">
      {{ 'no_data_available_label' | transloco }}
    </h6>

    <p class="text-neutral-500 text-sm font-medium mt-sm">
      {{ 'section_no_data_description' | transloco }}
    </p>
  </div>
} @else {
  <div class="cards-container flex gap-lg">
    @for (item of list(); track item.value) {
      <div
        class="flex flex-col justify-between gap-md p-lg bg-white border border-neutral-200 rounded-lg h-full"
        [class.cursor-pointer]="mode() === 'edit'"
        (click)="removeGroupUser(item)">
        <div class="flex items-center justify-between">
          @if (!item.image) {
            <div
              class="avatar flex items-center justify-center bg-primary-50"
              [class.rounded-full]="itemType() === 'User'"
              [class.rounded-xl]="itemType() !== 'User'">
              <span class="text-lg font-medium text-primary-500">
                {{ item.label | avatar }}
              </span>
            </div>
          } @else {
            <img
              class="avatar"
              [class.rounded-full]="itemType() === 'User'"
              [class.rounded-xl]="itemType() !== 'User'"
              [src]="item.image.url"
              [alt]="item.label" />
          }

          @if (mode() === 'edit') {
            <div>
              <svg
                width="25"
                height="24"
                class="size-6 text-destructive-500"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.6699 22C18.1699 22 22.6699 17.5 22.6699 12C22.6699 6.5 18.1699 2 12.6699 2C7.16992 2 2.66992 6.5 2.66992 12C2.66992 17.5 7.16992 22 12.6699 22Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M8.66992 12H16.6699"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          }

          @if (mode() === VIEW_MODE && actionList().length) {
            <lib-action-list
              [menuItems]="actionList()"
              (itemClick)="actionListItemClick($event, item)" />
          }
        </div>

        <div class="flex gap-md">
          <div class="flex flex-col gap-x-sm w-full">
            <p
              class="font-semibold text-base text-neutral-900 break-all text-balance line-clamp-3"
              [trimLength]="56"
              libTrimTooltip
              placement="top"
              [toolTipClass]="
                'bg-white p-md rounded-lg shadow-lg !w-4xl tooltip-arrow tooltip-arrow-top break-all text-balance'
              "
              [fullText]="item.label"></p>

            @let description =
              itemType() === 'Group'
                ? ('assign_items_modal_group_label' | transloco)
                : item.job_title ||
                  item.email ||
                  ('assign_items_modal_user_label' | transloco);

            <p
              class="text-neutral-700 text-xs2 font-medium line-break line-clamp-1"
              [trimLength]="42"
              libTrimTooltip
              placement="top"
              [toolTipClass]="
                'bg-white p-md rounded-lg shadow-lg tooltip-width tooltip-arrow tooltip-arrow-top'
              "
              [fullText]="description"></p>
          </div>
        </div>
      </div>
    }
  </div>
}
